// extracted by mini-css-extract-plugin
export var removeButton = "remove-button_TbJwPPIgNx3yqPiKY_9Z";